import { Promise } from 'es6-promise';
import { AppStore } from './Stores/AppStore';
import { Strings } from "./Stores/StringsStore";
import { Urls } from "./Urls";
import * as Utilities from "./Utilities";

const UI_CULTURE_HEADER_KEY: string = "X-Cdp-Culture";

export function ApiRequestAsync<T>(apiName: string, apiMethod: string, argument?: any): Promise<T> {

	return new Promise<T>((resolve: (result: T) => void, reject: (error: string) => void) => {
		try {
			let startTime = Utilities.stopWatch();
			let xhr: XMLHttpRequest = new XMLHttpRequest();
			let url = `/clientApi/${apiName}/${apiMethod}`;
			xhr.onreadystatechange = function (ev: ProgressEvent): any {
				if (xhr.readyState == 4) {

					let timeTaken = Utilities.stopWatch(startTime);

					if (xhr.status == 200) {
						let result: T = xhr.responseText == "{}" ? true : JSON.parse(xhr.responseText);
						Utilities.DebugLog(`ApiRequest time: ${timeTaken}ms api: ${apiName} method: ${apiMethod} succeded`);
						resolve(result);
					}
					else {
						Utilities.DebugLog(`ApiRequest time: ${timeTaken}ms api: ${apiName} method: ${apiMethod} failed with status: ${xhr.status} message: ${xhr.responseText}`);
						if (xhr.status == 400) {
							reject(xhr.responseText);
						}
						else if (xhr.status == 401) {
							reject(Strings.general.sessionTimeoutErrorMessage);
						}
						else if (xhr.status == 404) {
							let date = new Date(Date.now() + 5 * 60000);
							document.cookie = "Noxum.Search.NoResult=; expires=" + date.toString();
							AppStore.keepOnPage(Urls.reader);
						}
						else {
							reject(Strings ? Strings.general.generalErrorMessage : "An exception occured");
						}
					}
				}
			};
			xhr.ontimeout = function (ev: ProgressEvent): any {
				reject(Strings.general.timeoutErrorMessage);
			}
			let strData: string = JSON.stringify(argument);
			xhr.open("POST", url, true);
			xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
			let uiLang = Utilities.getUiLanguage();
			if (uiLang) {
				xhr.setRequestHeader(UI_CULTURE_HEADER_KEY, uiLang);
			}
			xhr.send(strData);
		}
		catch (e) {
			reject(Strings ? Strings.general.generalErrorMessage : "An exception occured");
		}
	});
}

export function ApiRequest<T>(apiName: string, apiMethod: string, argument?: any): T {
	let startTime = Utilities.stopWatch();
	let xhr: XMLHttpRequest = new XMLHttpRequest();
	let url = `/clientApi/${apiName}/${apiMethod}`;
	let strData: string = JSON.stringify(argument);
	xhr.open("POST", url, false);
	xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
	let uiLang = Utilities.getUiLanguage();
	if (uiLang) {
		xhr.setRequestHeader(UI_CULTURE_HEADER_KEY, uiLang);
	}
	xhr.send(strData);
	let timeTaken = Utilities.stopWatch(startTime);
	if (xhr.status == 200) {
		let result: T = xhr.responseText == "{}" ? true : JSON.parse(xhr.responseText);
		Utilities.DebugLog(`ApiRequest time: ${timeTaken}ms api: ${apiName} method: ${apiMethod} succeded`);
		return result;
	}
	else {
		Utilities.DebugLog(`ApiRequest time: ${timeTaken}ms api: ${apiName} method: ${apiMethod} failed with status: ${xhr.status} message: ${xhr.responseText}`);
		if (xhr.status == 400) {
			throw xhr.responseText;
		}
		else {
			throw Strings ? Strings.general.generalErrorMessage : "An exception occured";
		}
	}
}
